import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import _toConsumableArray from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.starts-with";
import { isSSR, client } from "./plugins/Platform.js";
import { noop } from "./utils/event.js";

var getTrue = function getTrue() {
  return true;
};

function filterInvalidPath(path) {
  return typeof path === 'string' && path !== '' && path !== '/' && path !== '#/';
}

function normalizeExitPath(path) {
  path.startsWith('#') === true && (path = path.substr(1));
  path.startsWith('/') === false && (path = '/' + path);
  path.endsWith('/') === true && (path = path.substr(0, path.length - 1));
  return '#' + path;
}

function getShouldExitFn(cfg) {
  if (cfg.backButtonExit === false) {
    return function () {
      return false;
    };
  }

  if (cfg.backButtonExit === '*') {
    return getTrue;
  } // Add default root path


  var exitPaths = ['#/']; // Add custom exit paths

  Array.isArray(cfg.backButtonExit) === true && exitPaths.push.apply(exitPaths, _toConsumableArray(cfg.backButtonExit.filter(filterInvalidPath).map(normalizeExitPath)));
  return function () {
    return exitPaths.includes(window.location.hash);
  };
}

export default {
  __history: [],
  add: noop,
  remove: noop,
  install: function install(cfg) {
    var _this = this;

    if (isSSR === true) {
      return;
    }

    var _client$is = client.is,
        cordova = _client$is.cordova,
        capacitor = _client$is.capacitor;

    if (cordova !== true && capacitor !== true) {
      return;
    }

    var qConf = cfg[cordova === true ? 'cordova' : 'capacitor'];

    if (qConf !== void 0 && qConf.backButton === false) {
      return;
    } // if the '@capacitor/app' plugin is not installed
    // then we got nothing to do


    if ( // if we're on Capacitor mode
    capacitor === true && ( // and it's also not in Capacitor's main instance
    window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) {
      return;
    }

    this.add = function (entry) {
      if (entry.condition === void 0) {
        entry.condition = getTrue;
      }

      _this.__history.push(entry);
    };

    this.remove = function (entry) {
      var index = _this.__history.indexOf(entry);

      if (index >= 0) {
        _this.__history.splice(index, 1);
      }
    };

    var shouldExit = getShouldExitFn(Object.assign({
      backButtonExit: true
    }, qConf));

    var backHandler = function backHandler() {
      if (_this.__history.length) {
        var entry = _this.__history[_this.__history.length - 1];

        if (entry.condition() === true) {
          _this.__history.pop();

          entry.handler();
        }
      } else if (shouldExit() === true) {
        navigator.app.exitApp();
      } else {
        window.history.back();
      }
    };

    if (cordova === true) {
      document.addEventListener('deviceready', function () {
        document.addEventListener('backbutton', backHandler, false);
      });
    } else {
      window.Capacitor.Plugins.App.addListener('backButton', backHandler);
    }
  }
};